import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { Images } from "../../assets/common";
import { kFormatter } from "../../constants/function";
import "./index.scss";

export default function TipCount({ tip, listens }) {
  return (
    <Box className="tip_card" title={tip}>
      <img
        src={tip ? Images.playlist_tip : Images.Most_Listened}
        alt="add"
        style={{ width: "15px", height: "15px" }}
      />
      <Typography style={{ fontSize: "14px", color: "#FFFFFF" }}>
        {tip
          ? kFormatter(tip.toFixed(1))
          : listens
          ? kFormatter(listens)
          : null}
      </Typography>
    </Box>
  );
}
